/**
 * Routes that supply their own logo header and must therefore suppress the portal header and
 * subheader entirely. /unauthorized has always behaved this way; /closed is built from the same
 * template and belongs with it.
 */
const FULL_PAGE_PATHS = ['/unauthorized', '/closed'];

/** Wizard routes: they keep the portal header, so sign-out stays reachable, but drop the subheader. */
const WIZARD_PATHS = ['/enrollment', '/enrollment-complete'];

/**
 * NavigationEnd.url carries the query string, so an equality test against '/enrollment' never
 * matches a real enrollment link. That is what silently disabled this in two of the three portals.
 */
function pathOf(url: string): string {
  return url.split('?')[0].split('#')[0];
}

export function isFullPageRoute(url: string): boolean {
  return FULL_PAGE_PATHS.includes(pathOf(url));
}

export function isWizardRoute(url: string): boolean {
  return WIZARD_PATHS.includes(pathOf(url));
}
